import {action} from 'typesafe-actions';
import {LayoutActionTypes} from './types';

/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
export const toggleSidebar = (showSidebar: boolean) =>
  action(LayoutActionTypes.TOGGLE_SIDEBAR, showSidebar);
